export default __webpack_public_path__ + "static/media/fb.9163a27b.jpeg";